const styles = {
  wrapper: 'bg-black tlight:bg-white teair:bg-white game:bg-game-blue-midnight',
};

export default styles;
